import Vue from 'vue';
import store from '@/store';
import VueKindergarten from 'vue-kindergarten';

Vue.use(VueKindergarten, {
    child: () => store.state.auth.user
});
